import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const quizSlice = createSlice({
  name: "quiz",
  initialState,
  reducers: {},
});

export const {} = quizSlice.actions;
export default quizSlice.reducer;
